import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import LottResultBody from "../../casinoComponents/refResultModal/LottResultBody";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

/**
 * Last Result for Lottery in the reference markup: the page renders
 *   .mb-3 > .casino-video-last-results > span.resultb "{win}" (e.g. "4  0  6")
 * (no .last-result-title on this reference page).
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the
 * reference result modal ("{ename} Result", modal-xl, .casino-result) with LottResultBody.
 * Refetches when the round id changes (reference: getLastResults on a new mid).
 */
export default function LottRefResults({ gameType = "lottcard", fallbackTitle = "Lottery", roundId }) {
  const apiType = String(gameType || "lottcard").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (alive && Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
    return () => {
      alive = false;
    };
  }, [apiType, roundId]);

  const handleResultClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <div className="mb-3">
      <div className="casino-video-last-results">
        {lastResults.map((r, i) => (
          <span key={`${r?.mid}-${i}`} className="resultb" onClick={() => handleResultClick(r?.mid)}>
            {r?.win}
          </span>
        ))}{" "}
      </div>
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={() => setShowModal(false)}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <LottResultBody t1={detailResult} />}
      </RefResultModal>
    </div>
  );
}
